

import { abibApi, tags, methods } from '.';
import { CountryListFilter, CountryListItem, Language, ListQuery, ListState, SuccessResponse } from '../types';

export const apiLanguage = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLanguages: builder.query<{ items: Language[] }, any>({
      query: (arg) => {
        return {
          method: methods.GET,
          url: `/languages/simplified`,
        };
      },
      providesTags: (result, error, params) => [tags.language, tags.languageList],
      transformResponse: ({ data }, meta, params) => ({
        items: data,
      }),
    }),
  }),
  overrideExisting: false,
});


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllLanguagesQuery,
} = apiLanguage;
